import {Breadcrumbs as MantineBreadcrumbs, BreadcrumbsProps as MantineBreadcrumbsProps} from "@mantine/core";

export type BreadcrumbsProps = MantineBreadcrumbsProps & {
  // extend props here
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const {...rest} = props;

  return <MantineBreadcrumbs {...rest} />;
};
